import { render, staticRenderFns } from "./RegionMembers.vue?vue&type=template&id=8ec34616&scoped=true&"
import script from "./RegionMembers.vue?vue&type=script&lang=js&"
export * from "./RegionMembers.vue?vue&type=script&lang=js&"
import style0 from "./RegionMembers.vue?vue&type=style&index=0&id=8ec34616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec34616",
  null
  
)

export default component.exports